// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
  // TOPのみ
  if (document.querySelector('.p-front .l-header')) {
    var $header = $('.l-header');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 50) {
        $header.addClass('is-scrolling');
      } else {
        $header.removeClass('is-scrolling');
      }
    });
  }
	
});